import React from 'react';
import css from './css.less';
import { EnumStatus } from 'src/types/common/product';
import Tag from '@/src/components/Antd/Tag/Tag';
import Menu from '@/src/components/Antd/Menu/Menu';
import MenuItem from '@/src/components/Antd/Menu/MenuItem/MenuItem/Menu';
import DropDown from '@/src/components/Antd/DropDown/DropDown';
import { DownOutlined } from '@ant-design/icons';
import Modal from 'src/components/Antd/Modal/GeneralModal';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { I18N_KEY_MAPPING } from '@/src/tools/constant';

const modalData = (obj) => {
  const { visible, header, body, onOk, onCancel, okText, cancelText } = obj;
  return {
    visible: visible || false,
    header: header || '',
    body: body || '',
    onOk: onOk || null,
    onCancel: onCancel || null,
    okText: okText || '',
    cancelText: cancelText || '',
  };
};
const Status = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { status, setArchived, setActive, setDraft, title, disabled } = props;

  const [modal, setModal] = React.useState({
    visible: false,
    header: '',
    body: '',
    onOk: null,
    onCancel: null,
    okText: '',
    cancelText: '',
  });
  const timeout = React.useRef<any>();

  const { visible, header, body, onOk, onCancel, okText, cancelText } = modal;

  const tagList = React.useMemo(() => {
    const list = [
      {
        value: EnumStatus.Draft,
        body: (
          <Tag color='warning' className={css.tagClass}>
            {getI18n(I18N_KEY_MAPPING[EnumStatus.Draft])}
          </Tag>
        ),
      },
      {
        value: EnumStatus.Active,
        body: (
          <Tag
            color='success'
            className={css.tagClass}
            status={EnumStatus.Active}>
            {getI18n(I18N_KEY_MAPPING[EnumStatus.Active])}
          </Tag>
        ),
      },
    ];
    if (status !== EnumStatus.Draft) {
      list.push({
        value: EnumStatus.Archived,
        body: (
          <Tag
            color='default'
            className={css.tagClass}
            status={EnumStatus.Archived}>
            {getI18n(I18N_KEY_MAPPING[EnumStatus.Archived])}
          </Tag>
        ),
      });
    }

    return list;
  }, [status]);
  const closeModal = () => {
    setModal({ ...modal, visible: false });
  };
  React.useEffect(() => {
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);
  const toDraft = () => {
    // visible, header, body, onOk, onCancel, okText, cancelText;
    setModal(
      modalData({
        visible: true,
        header: getI18n('allProducts.addproductset.saveandsettoDraft'),
        body: getI18n('allProducts.addproductset.draftingProductDesc'),
        onOk: () => {
          closeModal();
          timeout.current = setTimeout(() => {
            setDraft();
          }, 500);
        },
        onCancel: closeModal,
        okText: getI18n('allProducts.addproductset.settoDraft'),
        cancelText: getI18n('general.cancel'),
      }),
    );
  };
  const toActive = () => {
    setModal(
      modalData({
        visible: true,
        header: getI18n('allProducts.addproductset.saveandsettoactive'),
        body: getI18n(
          'allProducts.addproductset.activatingshowonsaleschannels',
        ),
        onOk: () => {
          closeModal();

          timeout.current = setTimeout(() => {
            setActive();
          }, 500);
        },

        onCancel: closeModal,
        okText: getI18n('allProducts.addproductset.settoActive'),
        cancelText: getI18n('general.cancel'),
      }),
    );
  };
  const toArchieve = () => {
    setModal(
      modalData({
        visible: true,
        header: getI18n('allProducts.addproductset.saveandsettoarchieve'),
        body: getI18n('allProducts.addproductset.archivingProductDesc'),
        onOk: () => {
          setArchived();
          timeout.current = setTimeout(() => {
            closeModal();
          }, 500);
        },
        onCancel: closeModal,
        okText: getI18n('general.archive'),
        cancelText: getI18n('general.cancel'),
      }),
    );
  };
  const statusOnChange = {
    [EnumStatus.Archived]: toArchieve,
    [EnumStatus.Active]: toActive,
    [EnumStatus.Draft]: toDraft, //setDraft,
  };
  const overlay = (
    <Menu
      disabled={disabled}
      selectedKeys={status}
      className={css.overlayClass}
      onSelect={(e) => {
        if (statusOnChange[e.key]) {
          statusOnChange[e.key]();
        } //statusOnChange[e.key]();
      }}>
      {tagList.map((list, index) => (
        <MenuItem className={css.overlaylist} key={list.value}>
          {list.body}
        </MenuItem>
      ))}
    </Menu>
  );
  const displayTag = React.useMemo(() => {
    const tag = tagList.find((i) => i.value === status);
    if (tag) {
      return tag.body;
    }
    return tagList[0].body;
  }, [status]);
  return (
    <div className={css.itemContainer}>
      <Modal
        visible={visible}
        header={header}
        onOk={onOk}
        onCancel={onCancel}
        okText={okText}
        cancelText={cancelText}>
        {body}
      </Modal>
      <DropDown overlay={overlay} trigger={['click']} disabled={disabled}>
        <div className={css.dropItem}>
          {displayTag}
          <DownOutlined className={css.overlayIcon} />
        </div>
      </DropDown>
      <p className={css.titleText}>{title}</p>
    </div>
  );
};
export default Status;
